import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-research-development-committee',
  templateUrl: './research-development-committee.component.html',
  styleUrls: ['./research-development-committee.component.scss']
})
export class ResearchDevelopmentCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
